import styles from './SimpleList.module.scss';
import { type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  ordered?: boolean;
  heading?: string;
  dropSpacing?: boolean;
  dropMarker?: boolean;
}

export function SimpleList({
  children,
  dropMarker,
  ordered,
  dropSpacing,
}: Props) {
  const className = [
    styles['simple-list'],
    dropMarker && styles['drop-marker'],
    (dropSpacing || dropMarker) && styles['drop-spacing'],
  ]
    .filter(Boolean)
    .join(' ');
  return ordered ? (
    <ol className={className}>{children}</ol>
  ) : (
    <ul className={className}>{children}</ul>
  );
}
